import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';
import { ProfileDialogComponent } from './profile.dialog.component';

const routes = [
    {
        path     : 'userdialog',
        component: ProfileDialogComponent
    }
];

@NgModule({
    declarations: [
        ProfileDialogComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ProfileDialogComponent
    ]
})

export class ProfileModule
{
}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/toolbar/profile/profile.dialog.module.ts